import { Component, OnInit } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
@Component({
  selector: 'my-personal-eliminar',
  styles: [],
  templateUrl: './personal-eliminar.component.html',
  providers: [generalService]
})
export class PersonalEliminarComponent implements OnInit {
  baja:any;
  formBaja:FormGroup;
  mensaje: string = "";
  constructor(
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private _generalService: generalService) { 
    this.baja = new Object();    
  }
  
  ngOnInit() {  
    this.buildForm();
  }

  aceptar(){
    this.deletePersonal();
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  deletePersonal(){
    const id:number = this.dataService.id;
    const reason:string = this.baja.REASON;
      this._generalService.metodoCall(`personal/eliminarPersonal?id=${id}&reason=${reason}`).subscribe(
          result => {
            this._generalService.toastCall("El registro se eliminó exitosamente!");  
            this.cerrarModal();          
            },
          error => {
            console.log(<any>error);
            this.cerrarModal();
          }
        );
    }

  buildForm() {
      this.formBaja = this.formBuilder.group({
        REASON: this.formBuilder.control(null, [Validators.required, Validators.maxLength(200)])        
      });
    }
}


// WEBPACK FOOTER //
// ./src/app/personal/consultar-eliminar/personal-eliminar.component.ts